module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: " pull-left sidebar-width sm-table hidden-xs hidden-sm"
  }, [_c('div', {
    staticClass: "header-inner"
  }, [_c('div', {
    staticClass: "brand inline"
  }, [_c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.brand)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: " pull-right"
  }, [_c('div', {
    staticClass: "visible-lg visible-md m-t-10"
  }, [_c('div', {
    staticClass: "dropdown pull-left p-r-10 p-t-10 fs-16"
  }, [_c('a', {
    staticClass: "small",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "aria-haspopoup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v(_vm._s(_vm.$auth.current.data.name))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-caret-down"
  }, [_vm._v(" ")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu profile-dropdown",
    attrs: {
      "role": "menu"
    }
  }, [_vm._m(1, false, false), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('li', {
    staticClass: "bg-master-lighter"
  }, [_c('a', {
    staticClass: "clearfix",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "pull-left",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")]), _vm._v(" "), _vm._m(3, false, false)])])])])])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "pull-left m-t-20"
  }, [_c('ul', {
    staticClass: "notification-list no-margin hidden-sm hidden-xs b-grey no-style p-l-30 p-r-20"
  }, [_c('li', {
    staticClass: "p-r-5 inline"
  }, [_c('div', {
    ref: "notifications",
    staticClass: "dropdown"
  }, [_vm._m(4, false, false), _vm._v(" "), _vm._m(5, false, false)])]), _vm._v(" "), (false) ? _c('li', {
    staticClass: "p-r-15 inline"
  }, [_c('div', {
    staticClass: "pointer",
    on: {
      "click": _vm.showUnread
    }
  }, [_vm._m(6, false, false)])]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid relative"
  }, [_c('div', {
    staticClass: "pull-left full-height visible-sm visible-xs"
  }, [_c('div', {
    staticClass: "header-inner"
  }, [_c('a', {
    staticClass: "btn-link toggle-sidebar visible-sm-inline-block visible-xs-inline-block padding-5",
    attrs: {
      "href": "#",
      "data-toggle": "sidebar"
    }
  }, [_c('span', {
    staticClass: "icon-set menu-hambuger"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "pull-center hidden-md hidden-lg"
  }, [_c('div', {
    staticClass: "header-inner"
  }, [_c('div', {
    staticClass: "brand inline"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right full-height visible-sm visible-xs"
  }, [_c('div', {
    staticClass: "header-inner"
  }, [_c('a', {
    staticClass: "btn-link visible-sm-inline-block visible-xs-inline-block",
    attrs: {
      "href": "#",
      "data-toggle": "quickview",
      "data-toggle-element": "#quickview"
    }
  }, [_c('span', {
    staticClass: "icon-set menu-hambuger-plus"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#/profile"
    }
  }, [_c('i', {
    staticClass: "pg-settings_small"
  }), _vm._v(" Profile")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#/help"
    }
  }, [_c('i', {
    staticClass: "pg-signals"
  }), _vm._v(" Help")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right"
  }, [_c('i', {
    staticClass: "pg-power"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "icon-set globe-fill",
    attrs: {
      "href": "javascript:;",
      "id": "notification-center",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "bubble"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown-menu notification-toggle",
    attrs: {
      "role": "menu",
      "aria-labelledby": "notification-center"
    }
  }, [_c('div', {
    staticClass: "notification-panel"
  }, [_c('div', {
    staticClass: "notification-body scrollable"
  }, [_c('div', {
    staticClass: "notification-item unread clearfix"
  }, [_c('div', {
    staticClass: "heading open"
  }, [_c('a', {
    staticClass: "text-complete pull-left",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "pg-map fs-16 m-r-10"
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Welcome")]), _vm._v(" "), _c('span', {
    staticClass: "fs-12 m-l-10"
  }, [_vm._v("Proximi.io")])]), _vm._v(" "), _c('div', {
    staticClass: "more-details"
  }, [_c('h5', {
    staticClass: "semi-bold fs-16"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "option",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "left",
      "title": "mark as read"
    }
  }, [_c('a', {
    staticClass: "mark",
    attrs: {
      "href": "#"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "notification-footer text-center"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Read all notifications")]), _vm._v(" "), _c('a', {
    staticClass: "portlet-refresh text-black pull-right",
    attrs: {
      "data-toggle": "refresh",
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "pg-refresh_new"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("You have "), _c('span', {
    staticClass: "text-black bold"
  }, [_vm._v("1")]), _vm._v(" unread notification")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e625b13"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/navbar.vue
// module id = 1262
// module chunks = 1